import { Dispatch, SetStateAction } from "react"
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { TestResultForm } from "../../types"

type TestTypeField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const TestTypeField = (props: TestTypeField) => {
  const { formData, setFormData } = props

  const options = [
    'MyCheck In-Office Waterline Tests',
    'FastCheck15 In-Office Waterline Tests'
  ]

  const handleChange = (event: SelectChangeEvent<string>) => {
    const nextForm = structuredClone(formData)

    nextForm.hpc_method = event.target.value || null

    setFormData(nextForm)
  }

  const label = 'Test Type *'
  const value = formData.hpc_method ?? ''
  const placeholder = 'Select Type of Test Used'

  return (
    <Box>
      <FormControl fullWidth size="small" sx={{ width: '100%' }}>
        <InputLabel>
          { label }
        </InputLabel>
        <Select
          value={value}
          label={label}
          onChange={(event) => handleChange(event)}
          placeholder={placeholder}
        >
          {
            options.map(option => {
              return (
                <MenuItem key={option} value={option}>
                  { option }
                </MenuItem>
              )
            })
          }
        </Select>
      </FormControl>
    </Box>
  )
}

export default TestTypeField
